import DisplayDataServer from "../../components/admin/DisplayDataServer";
const Contact=()=>{
   return <DisplayDataServer name={"Contact"} type={"contact"}/>;
}

export default Contact;